import { useAxios } from "@/services/axios";
import { HTTP_PRODUCT_FRUITS } from "@/services/enums/httpEnum";
import type { ProductFruitsHmacResponse } from "@/types/productFruits.types";

/**
 * Fetch HMAC from the main API
 * Uses JWT token authentication via useAxios interceptor
 * @returns Promise with HMAC response containing hmac, username, and workspace_id
 */
export const fetchProductFruitsHmac =
  async (): Promise<ProductFruitsHmacResponse> => {
    const response = await useAxios.get<ProductFruitsHmacResponse>(
      HTTP_PRODUCT_FRUITS.PRODUCT_FRUITS_HMAC
    );

    return response.data;
  };
